import React, { useEffect } from "react";
import "../_css/Home.css";
import PdfUI from "../_components/UI/PdfUI";
import Header from '../_components/common/Header'
import StudentList from "../_components/UI/StudentList";
import ReviewAns from "../_components/UI/ReviewAns";
import Loader from "../_components/common/Loader";
const Home = () => {
  
  return (
    <div className='page-main'>
       
      <Header name= {['Upload Answer Sheets'] }/>
      <PdfUI />
    </div>
  );
};

export default Home;
